import script from "./cFormGroup.vue?vue&type=script&lang=js"
export * from "./cFormGroup.vue?vue&type=script&lang=js"

import "./cFormGroup.vue?vue&type=style&index=0&id=54a20b79&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54a20b79"],['__file',"src/components/cmp/cForm/cFormGroup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "54a20b79"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('54a20b79', __exports__)) {
    api.reload('54a20b79', __exports__)
  }
  
}


export default __exports__